import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class AmpFormUidColumnIndex extends Component {

  static propTypes = {
    defaultValue: PropTypes.number.isRequired,
    /**
     * Change callback
     * @param {String} value
     */
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      uidColumnIndex: props.defaultValue,
    };
  }

  handleChange = (event, val) => {
    this.setState({ uidColumnIndex: val });
    // Bring focus to textfield when other is selected
    this.props.onChange(val);
  }

  render() {
    return (
      <div>
        <SelectField
          name="uid_column_index"
          value={this.state.uidColumnIndex}
          onChange={this.handleChange}
        >
          <MenuItem value={0} primaryText="First" />
          <MenuItem value={1} primaryText="Second" />
          <MenuItem value={2} primaryText="Third" />
          <MenuItem value={3} primaryText="Forth" />
          <MenuItem value={4} primaryText="Fifth" />
          <MenuItem value={5} primaryText="Sixth" />
          <MenuItem value={6} primaryText="Seventh" />
          <MenuItem value={7} primaryText="Eight" />
          <MenuItem value={8} primaryText="Nineth" />
          <MenuItem value={9} primaryText="Thenth" />
        </SelectField>
      </div>
    );
  }
}
export default AmpFormUidColumnIndex;



// WEBPACK FOOTER //
// ./src/components/AmpFormUidColumnIndex/index.jsx